
import MappingManager from '@/shared/mappingManager'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppLogo',
  methods: {
    logCameraPos: function (): void {
      MappingManager.getInstance().logCameraPos()
      // MappingManager.getInstance().test()
    }
  }
})
